import { render, staticRenderFns } from "./IncomesSummary.vue?vue&type=template&id=38d579a4&scoped=true"
import script from "./IncomesSummary.vue?vue&type=script&lang=js"
export * from "./IncomesSummary.vue?vue&type=script&lang=js"
import style0 from "./IncomesSummary.vue?vue&type=style&index=0&id=38d579a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d579a4",
  null
  
)

export default component.exports